const regexesValidation = {
  isNumber: /^-?\d+([.,]\d+)?$/g,
  isEmail: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  isNumberPositiveOnly: /^\d+([.,]\d+)?$/g,
};

export default regexesValidation;
